import { Component, Input } from '@angular/core';
import { CostPerUnitVM } from '@innogy/become-a-customer/shared/interfaces';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { GenericRichTextDirective, getFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import { ComponentFields, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { SegmentType } from '@essent/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { AomCostsPerUnitWithSummerWinterComponent } from './aom-costs-per-unit-with-summer-winter/aom-costs-per-unit-with-summer-winter.component';
import { AomCostsPerUnitWithoutSummerWinterComponent } from './aom-costs-per-unit-without-summer-winter/aom-costs-per-unit-without-summer-winter.component';

@Component({
  selector: 'wl-aom-costs-per-unit',
  templateUrl: './aom-costs-per-unit.component.html',
  styleUrls: [
    './aom-costs-per-unit.component.ed.scss',
    './aom-costs-per-unit.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    AomCostsPerUnitWithSummerWinterComponent,
    AomCostsPerUnitWithoutSummerWinterComponent,
    GenericRichTextDirective,
    CSCaptureDirective,
    AutomationIdDirective,
  ],
})
export class AomCostsPerUnitComponent {
  SegmentType = SegmentType;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public costPerUnitVM?: CostPerUnitVM;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fields?: ComponentFields;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public isVATIncluded?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public isDynamicProduct? = false;

  constructor(private readonly currencyPipe: CurrencyPipe) {}

  get electricityFixedDelivery() {
    return this.transformCurrency(
      this.costPerUnitVM?.electricity?.fixedDeliveryDailyCosts,
      '1.5-5'
    );
  }

  get electricityFixedRedelivery() {
    return this.transformCurrency(
      this.costPerUnitVM?.electricity?.fixedRedeliveryDailyCosts,
      '1.5-5'
    );
  }

  get gasDelivery() {
    return this.transformCurrency(
      this.costPerUnitVM?.gas?.fixedDeliveryDailyCosts,
      '1.5-5'
    );
  }

  get aomCostsPerUnitLabel(): string | undefined {
    return getFieldValue<string>(this.fields, 'AomCostsPerUnitDayLabel');
  }

  private transformCurrency(value?: number, digitsInfo = '1.2') {
    return this.currencyPipe.transform(value, 'EUR', 'symbol', digitsInfo);
  }

  get isSummerWinter(): boolean {
    return (
      this.costPerUnitVM?.electricity?.tariffPeriods?.[0]?.winterPrice !==
      undefined
    );
  }
}
